module.exports = "//web.yystatic.com/project/yycom_header/pc/images/2wm-flink-6cb6f4ca.png";